import { COMPARE_STATUS, STATUS } from "./status";

export const passedNonCloudRole = (passedStack='', cloudRoles='') => {
    // Convert the passedStack to an array of integers
    const stack = passedStack.split(',').map(Number);
  
    // Convert the cloudRoles to an array of integers
    const cloudRolesArray = cloudRoles.split(',').map(Number);
  
    // Check if any role in the stack is not in the cloudRolesArray
    const nonCloudRoles = stack.filter(role => !cloudRolesArray.includes(role));
    // Return true if there are any non-cloud roles, otherwise false
    return nonCloudRoles.length > 0;
}

const canAccessPage = (pageName, userStatus) => {
    const unlockedByDefault = ['turing_test', 'finalize_resume'];

    const {
        isProgrammerRole,
        extraPassedInfo: { passedAcc, passedStacks, passed1stMCQ },
        status: devStatus,
        cloudRoleIds,
        jobsPageEnabled,
        coreSkillPassed,
        flags,
        workExpCompleted,
        showCoreQuiz,
        passedAdditionalMCQ
    } = userStatus;
    
    const {
        $flagsReady = false
    } = flags;

    if (!$flagsReady) return true;

    const hasPassedTI = COMPARE_STATUS(devStatus, STATUS.PASSED_TI) >= 0;
    const enableChallengeTabGeneralCondition = COMPARE_STATUS(devStatus, STATUS.SCHEDULING_TECH_INTERVIEW) >= 0
        || (showCoreQuiz && coreSkillPassed) || (!showCoreQuiz && passedAdditionalMCQ)
        || devStatus === STATUS.FAILED 
        || devStatus === STATUS.FAILED_ACC
    const hasPassedCoreMCQ = flags.use_role_based_mcq_uiux ?  enableChallengeTabGeneralCondition : workExpCompleted && enableChallengeTabGeneralCondition;
    const checkPassedNonCloudRole = passedNonCloudRole(passedStacks, cloudRoleIds);

    const hideMomentOfDelightTechPassed = !checkPassedNonCloudRole && !hasPassedTI;
    localStorage.setItem("hideMomentOfDelightTechPassed", hideMomentOfDelightTechPassed.toString());

    const allowedPages = unlockedByDefault.reduce((acc, page) => {
        acc[page] = true;
        return acc;
    }, {});

    if (!unlockedByDefault.includes(pageName)) {
        allowedPages[pageName] = false;
    }

    allowedPages.coding_challenge = hasPassedCoreMCQ;
    allowedPages.soft_skills = passedAcc;
    allowedPages.recommended_job = passedAcc || !isProgrammerRole;


    allowedPages.job = jobsPageEnabled;
    return allowedPages[pageName] || false;
};


export default canAccessPage;